import React from 'react';
import { useStripeConfig } from '../context/StripeConfigContext';

interface StripeToggleProps {
  showInProduction?: boolean; // Set to false to hide before launch
}

const StripeToggle: React.FC<StripeToggleProps> = ({ showInProduction = true }) => {
  const { mode, toggleMode, isSandbox } = useStripeConfig();

  // Hide component if showInProduction is false
  if (!showInProduction) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-heading font-bold text-sm uppercase tracking-wide mb-1">
            Stripe Payment Mode
          </h3>
          <p className="font-body text-xs text-gray-600">
            {isSandbox ? (
              <>Test mode - Use test card <code className="bg-gray-100 px-1 rounded">4242 4242 4242 4242</code></>
            ) : (
              <span className="text-red-600 font-semibold">LIVE MODE - Real charges will be made</span>
            )}
          </p>
        </div>

        <button
          onClick={toggleMode}
          className={`
            relative inline-flex h-8 w-16 items-center rounded-full transition-colors
            ${isSandbox ? 'bg-blue-500' : 'bg-red-500'}
          `}
          aria-label="Toggle Stripe mode"
        >
          <span
            className={`
              inline-block h-6 w-6 transform rounded-full bg-white transition-transform
              ${isSandbox ? 'translate-x-1' : 'translate-x-9'}
            `}
          />
          <span className={`
            absolute text-xs font-bold text-white
            ${isSandbox ? 'left-2' : 'left-1'}
          `}>
            {isSandbox ? 'TEST' : 'LIVE'}
          </span>
        </button>
      </div>

      {!isSandbox && (
        <div className="mt-2 text-xs text-red-600 font-body">
          ⚠️ Warning: You are in LIVE mode. Real payment cards will be charged.
        </div>
      )}
    </div>
  );
};

export default StripeToggle;
